import SectionHeading from "@/components/SectionHeading";
import { StaggerGroup, StaggerItem } from "@/components/motion";
import { PROCESS } from "@/data/site";
import { ArrowRight } from "lucide-react";

export default function ProcessTimeline() {
  return (
    <section data-testid="process-timeline" className="bg-white py-8">
      <div className="nc-container">
        <SectionHeading
          eyebrow="How It Works"
          title={<>Four steps from where you are to <span className="text-[#2FA86A]">where you want to be.</span></>}
        />

        <StaggerGroup className="relative mt-16 grid gap-8 md:grid-cols-4">
          {/* connecting line */}
          <div className="pointer-events-none absolute left-0 right-0 top-[46px] hidden h-px bg-gradient-to-r from-[#142A5E]/10 via-[#142A5E]/25 to-[#2FA86A]/40 md:block" />
          {PROCESS.map((p, i) => (
            <StaggerItem key={p.n}>
              <div data-testid={`process-step-${p.n}`} className="relative">
                <div className="flex items-center gap-4 md:block">
                  <div className="relative z-10 inline-flex h-[92px] w-[92px] items-center justify-center rounded-2xl bg-[#142A5E] font-display text-3xl font-extrabold text-white shadow-[0_16px_30px_-12px_rgba(29,61,143,0.6)]">
                    {p.n}
                  </div>
                  {i < PROCESS.length - 1 && (
                    <div className="absolute left-full top-[46px] z-10 ml-4 hidden -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white p-1 md:flex">
                      <ArrowRight className="h-4 w-4 text-[#2FA86A]" />
                    </div>
                  )}
                </div>
                <h3 className="mt-6 font-display text-xl font-bold text-[#1B1B1B]">{p.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-[#1B1B1B]/60">{p.desc}</p>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
